/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { ICellRendererParams } from 'ag-grid-community';
import { SettingsContext } from 'components/dashboard/Visualization/SettingsContext';
import { LineCrossingType } from 'components/dashboard/VisualizationSettings/LocationSelectionObject';
import { useAtom } from 'jotai';
import { getContrastColor } from 'jotai/vehicleColor/ColorObject';
import { visualizationSettingsAtomFamily } from 'jotai/visualizationSettings';
import { ReactNode, useContext } from 'react';

const LocationRenderer = (props: ICellRendererParams): ReactNode => {
  const settingsId = useContext(SettingsContext);
  const [settings] = useAtom(visualizationSettingsAtomFamily(settingsId));
  const highlightLoopNames = [
    settings.locationHighlightSelections.location,
    LineCrossingType.PI,
    LineCrossingType.PO,
    LineCrossingType.SFP,
  ];
  const isHighlighted = highlightLoopNames.includes(props.data.loopName) || props.data.pitStatus;
  const highlightColor = settings.locationHighlightSelections.color ?? '#FFFFFF';
  const style = `
                .flashing-cell {
                  color: ${getContrastColor(highlightColor)}{};
                  font-weight: bold;
                  animation: flashBG 1s ease-out forwards;
                }

                @keyframes flashBG {
                  from { background-color: #FFF; }
                  to { background-color: ${highlightColor}; }
                }`;

  return (
    <>
      <style>{style}</style>
      <div className={`${isHighlighted ? 'flashing-cell' : ''}`}>{props.data.loopName}</div>
    </>
  );
};

export default LocationRenderer;
